import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class BranchService {
  constructor(private httpService: HttpService) { }
  fetchBranches() {
    return this.httpService.get('api/Branch');
  }
  deleteBranches(params: URLSearchParams): Observable<any> {
    return this.httpService.delete('api/Branch?' + params.toString());
  }
  submitBranchMaster(payload: any) {
    if (payload?.id) {
      return this.httpService.put('api/Branch', payload);
    } else {
      return this.httpService.post('api/Branch', payload);
    }
  }
}
